var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueBadge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 147,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.02%",
    y1: "25.71%",
    x2: "91.89%",
    y2: "75.28%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1565C0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.85.65l60.38 34.17a5 5 0 0 1 2.54 4.35v68.17a5 5 0 0 1-2.54 4.35l-60.38 34.17a5 5 0 0 1-4.93 0L2.54 111.7A5 5 0 0 1 0 107.34V39.17a5 5 0 0 1 2.54-4.35L62.92.65a5 5 0 0 1 4.93 0z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6 12.65l49.79 28.17a5 5 0 0 1 2.53 4.35v56.17a5 5 0 0 1-2.53 4.35L67.6 133.86a5 5 0 0 1-4.92 0L12.9 105.7a5 5 0 0 1-2.54-4.35V45.17a5 5 0 0 1 2.54-4.35l49.78-28.17a5 5 0 0 1 4.92 0z",
    id: "c"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-.4%",
    y: "-6.7%",
    width: "100.8%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    in: "SourceAlpha",
    result: "shadowSpreadInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowSpreadInner1",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-28.6%",
    y: "-28.6%",
    width: "157.1%",
    height: "157.1%",
    filterUnits: "objectBoundingBox",
    id: "e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.38 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#209CEA",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    transform: "translate(44 53)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0h42v42H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4FB6F7",
    d: "M42 41.96L21 20.98 42 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6E5FC",
    d: "M0 0l21 20.98L0 41.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#198BDB",
    d: "M0 42l20.98-21 20.98 21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M41.96 0L20.98 21 0 0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blue-badge.6891a2ee326eff6335a88302da3a4ab5.svg";